import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Split-screen authentication frame shared by signin, signup, reset, forgot and confirm.
 */
@Component({
  selector: 'app-auth-shell',
  templateUrl: './auth-shell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'auth-shell-host',
  },
})
export class AuthShellComponent {
  readonly title = input.required<string>();
  readonly subtitle = input<string>('');
}
